<div mat-dialog-title aria-label="Report Settings" class="d-flex row no-gutters">
  <h2>{{ data.name }}</h2>
  <button class="ml-auto" mat-button (click)="cancel()">
    <mat-icon aria-label="Cancel" class="fa" fontIcon="fa-times"></mat-icon>
  </button>
</div>

<div mat-dialog-content class="flex-column col">
  <div class="padding-lg">
    <div class="setting px-3" *ngFor="let settingId of data.settings.settingIds">
      <div class="row pt-2 setting-title">
        <div class="col-9">
          <h3>{{ data.settings[settingId].title }} </h3>
        </div>
        <div class="col-3 text-right" >
          <button *ngIf="data.settings[settingId].refresh" mat-icon-button color="primary" (click)="callSettingRefresh(settingId)"><mat-icon class="fa fa-rotate-right"></mat-icon></button>
          <mat-slide-toggle
            *ngIf="data.settings[settingId].showOnReportOptionAvailable && data.settings[settingId].displayTextFunction"
            class="setting-desc-visible"
            color="primary"
            labelPosition="before"
            [(ngModel)]="data.settings[settingId].configs.visible"
          >Show on report</mat-slide-toggle>
        </div>
      </div>
      <div class="row">
        <div [ngSwitch]="data.settings[settingId].type" class="col">
          <div *ngSwitchCase="'colorSelector'">
            <mat-slide-toggle class="mat-primary mb-4" tabindex="-1" (change)="setThemeColorsVisibility(data.settings[settingId])" [(ngModel)]="data.settings[settingId].value.active" aria-label="">
              {{ data.settings[settingId].displayTextFunction ? data.settings[settingId].displayTextFunction() || '' : '' }}
            </mat-slide-toggle>
            <div class="d-flex flex-sm-row justify-content-sm-start flex-column flex-sm-wrap justify-content-start" *ngIf="data.settings[settingId].id === 'themeColors' && data.settings[settingId].value.active">
              <ng-container *ngFor="let option of data.settings[settingId].value.selectedColors index as i">
                <div class="mb-2 d-flex pr-4 justify-content-between color-option-container">
                <mat-label class="pr-1 align-self-center" *ngIf="option.visible === true && option.label">{{option.label+':'}}</mat-label>
                <input *ngIf="option.visible === true" #colorOption
                       type="color"
                       [value]="option.color"
                       (change)="data.settings[settingId].value.selectedColors[i].color = colorOption.value">
                </div>
              </ng-container>
            </div>
          </div>
          <div *ngSwitchCase="'boolean'">
            <mat-slide-toggle class="mat-primary mb-4" tabindex="-1" [(ngModel)]="data.settings[settingId].value" aria-label="">
              {{ data.settings[settingId].displayTextFunction ? data.settings[settingId].displayTextFunction() || '' : '' }}
            </mat-slide-toggle>
          </div>
          <div *ngSwitchCase="'smallText'">
            <mat-form-field>
              <input matInput [(ngModel)]="data.settings[settingId].value" name="smalltext" aria-label="" />
            </mat-form-field>
          </div>
          <div *ngSwitchCase="'profileSelect'" class="smallTextContainer">
            <mat-form-field>
              <input matInput [(ngModel)]="data.settings[settingId].value.name"  />
            </mat-form-field>
          </div>
          <div *ngSwitchCase="'date'">
            <mat-form-field>
              <input acsDatePickerEvtHandler matInput [matDatepicker]="picker" [(ngModel)]="data.settings[settingId].value" />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker acsDatePickerEvtHandler #picker></mat-datepicker>
            </mat-form-field>
            <mat-slide-toggle tabindex="-1" class="mat-primary ml-2" [(ngModel)]="data.settings[settingId].configs.autoResetDaily" aria-label="Reset the date every day">
              Reset daily
            </mat-slide-toggle>
          </div>
          <div *ngSwitchCase="'multiselect'">
            <acs-option-multi-select [setting]="data.settings[settingId]"></acs-option-multi-select>
          </div>
          <div *ngSwitchCase="'multiCheck'" class="d-flex justify-content-between">
            <acs-option-multi-select class="d-flex flex-column align-items-center w-100 pb-2" [singleColumn]="true" [setting]="data.settings[settingId]"></acs-option-multi-select>
          </div>
          <div *ngSwitchCase="'autoComplete'">
            <acs-auto-complete class="mb-3" [(setting)]="data.settings[settingId]" required="data.settings[Id].required" [productTypeId]="6"></acs-auto-complete>
          </div>
          <div *ngSwitchCase="'singleSelect'" class="mat-block">
            <mat-form-field>
              <mat-select [disableOptionCentering]="true" aria-label="select option" [(value)]="data.settings[settingId].value" name="option">
                <mat-option *ngFor="let item of data.settings[settingId].options; trackBy: getIdentifierForIterableItem" [value]="item">
                  {{ item.name || item }}
                </mat-option>
              </mat-select>

            </mat-form-field>
          </div>
          <div *ngSwitchDefault>
            [REPORT SETTING OF TYPE {{ settingId }} NOT AVAILABLE]
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions class="justify-content-end align-items-center">
  <button class="mat-primary mat-button" color="primary" mat-raised-button [disabled]="!hasChanges()" (click)="close()">Save</button>
</div>
